import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import { BrowseFilesLink, UploadBoxWrapper, UploadTextWrapper } from '../BulkDocumentsStyles';
import { Typography } from '@totalsoft/rocket-ui';

export const UploadTargetBox = ({ onDrop }) => {
  const { t } = useTranslation();

  const fileInputRef = useRef();
  const [{ canDrop }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item) {
        if (onDrop) {
          onDrop(item);
        }
      },
      canDrop() {
        return true;
      },
      hover(item) {
        console.log('hover', item.files, item.items);
      },
      collect: monitor => {
        const item = monitor.getItem();
        if (item) {
          console.log('collect', item.files, item.items);
        }
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop()
        };
      }
    }),
    [onDrop]
  );

  const handleUploadClick = useCallback(() => fileInputRef.current.click(), []);
  const isActive = canDrop; /* && isOver*/

  return (
    <UploadBoxWrapper ref={drop}>
      {isActive ? (
        <UploadTextWrapper>
          <Typography variant='subtitle1' color='textPrimary'>
            {t('BulkPdf.DropFiles')}
          </Typography>
        </UploadTextWrapper>
      ) : (
        <UploadTextWrapper>
          <Typography variant='subtitle2' color='textPrimary'>
            {t('BulkPdf.DragInput')}
          </Typography>
          <Typography variant='subtitle2' color='textPrimary'>
            {t('BulkPdf.OrInput')}
          </Typography>
          <BrowseFilesLink variant='subtitle2' color='primary' onClick={handleUploadClick}>
            {t('BulkPdf.BrowseInput')}
          </BrowseFilesLink>
          <input ref={fileInputRef} hidden type='file' multiple onChange={onDrop} />
        </UploadTextWrapper>
      )}
    </UploadBoxWrapper>
  );
};

UploadTargetBox.propTypes = {
  onDrop: PropTypes.func
};
